import { PrismicRichText } from "@prismicio/react";
import React from 'react';
import ScriptInjector from "../script-injector";

export const ResourcePageDetail = (props) => {

    const sc = props.slice.primary;

    const stats = props.slice.items;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }

    

    return (
        <section className="gutter top res-sec">
            <div className="res-section wrapper flex flex-col md:flex-row justify-between gap-2 md:gap-24 pb-14 md:pb-24">
                <div className="w-full md:w-1/5">
                    <div className="res-label">{sc.section_name}</div>
                    <div>
                        {stats.map((data, index) => {
                            return (
                                <div key={index} className="detail mt-4 md:mt-12">
                                    <img src={data.icon.url} alt="" className="w-8 opacity-30 mb-2" />
                                    <p><strong>{data.detail_label}</strong></p>
                                    <PrismicRichText field={data.detail_content.richText} components={components} />
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className="w-full md:w-4/5 self-start">
                    <PrismicRichText field={sc.content.richText} components={components} />
                    <ScriptInjector html={sc.custom} />
                </div>
                
            </div>
        </section>
    );
}

